export const getters = {
  getFacilities: state => (state.facilities.length > 0 ? state.facilities : [])
};
